var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h5l2 3h9a2 2 0 012 2v11z",
    stroke: "#476FF2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMiAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxIDE3QzIxIDE3LjUzMDQgMjAuNzg5MyAxOC4wMzkxIDIwLjQxNDIgMTguNDE0MkMyMC4wMzkxIDE4Ljc4OTMgMTkuNTMwNCAxOSAxOSAxOUgzQzIuNDY5NTcgMTkgMS45NjA4NiAxOC43ODkzIDEuNTg1NzkgMTguNDE0MkMxLjIxMDcxIDE4LjAzOTEgMSAxNy41MzA0IDEgMTdWM0MxIDIuNDY5NTcgMS4yMTA3MSAxLjk2MDg2IDEuNTg1NzkgMS41ODU3OUMxLjk2MDg2IDEuMjEwNzEgMi40Njk1NyAxIDMgMUg4TDEwIDRIMTlDMTkuNTMwNCA0IDIwLjAzOTEgNC4yMTA3MSAyMC40MTQyIDQuNTg1NzlDMjAuNzg5MyA0Ljk2MDg2IDIxIDUuNDY5NTcgMjEgNlYxN1oiIHN0cm9rZT0iIzQ3NkZGMiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";
export { SvgFolderIcon as ReactComponent };